const Panel = () => import('@/views/panel/Panel.vue');

const TransactionsList = () => import('@/views/panel/lists/TransactionsList.vue');
const ImprestSettlementsList = () => import('@/views/panel/lists/ImprestSettlementsList.vue');
const FactorsList = () => import('@/views/panel/lists/FactorsList.vue');
const FactorsAggregatedSanadsList = () => import('@/views/panel/lists/FactorsAggregatedSanadsList.vue');
const SanadsList = () => import('@/views/panel/lists/SanadsList.vue');
const SanadItemsList = () => import('@/views/panel/lists/SanadItemsList.vue');
const TransfersList = () => import('@/views/panel/lists/TransfersList.vue');
const ChequesList = () => import('@/views/panel/lists/ChequesList.vue');
const AdjustmentsList = () => import('@/views/panel/lists/AdjustmentsList.vue');
const WarehouseHandlingList = () => import('@/views/panel/lists/WarehouseHandlingList.vue');
const SalePricesList = () => import('@/views/panel/lists/SalePricesList.vue');

const AccountsCoding = () => import('../views/panel/account/Coding');

const AccountsBalance = () => import('../views/panel/balance/accounts/AccountsBalance.vue');
const FloatAccountsBalanceByGroup = () => import('../views/panel/balance/floatAccountsByGroup/FloatAccountsBalanceByGroup.vue');
const FloatAccountsBalance = () => import('../views/panel/balance/floatAccounts/FloatAccountsBalance.vue');

const Ledger = () => import('@/views/panel/ledger/Ledger.vue');
const Bill = () => import('@/views/panel/bill/Bill.vue');
const Journal = () => import('@/views/panel/journal/Journal.vue');
const IncomeStatement = () => import('@/views/panel/incomeStatement/IncomeStatement.vue');
const BalanceSheet = () => import('@/views/panel/balanceSheet/BalanceSheet.vue');
const BuySaleReport = () => import('@/views/panel/buySaleReport/BuySaleReport.vue');

const DetailedWareInventory = () => import('@/views/panel/inventory/ware/DetailedWareInventory.vue');
const AllWaresInventory = () => import('@/views/panel/inventory/ware/AllWaresInventory.vue');
const DetailedWarehouseInventory = () => import('@/views/panel/inventory/warehouse/DetailedWarehouseInventory.vue');
const AllWarehousesInventory = () => import('@/views/panel/inventory/warehouse/AllWarehousesInventory.vue');
const InventoryProfitReport = () => import("@/views/panel/inventoryProfitReport/InventoryProfitReport");
const SanadListTabs = () => import("@/views/modulePages/accountingModule/SanadListTabs");
const ChequeTable = () => import("@/views/reports/ChequeTable");
const FactorsTable = () => import("@/views/reports/FactorsTable");
const PersonReport = () => import("@/views/panel/personReport/PersonReport");
const ContraryToNatureAccountsBalance = () => import("@/views/panel/balance/accounts/ContraryToNatureAccountsBalance");
const BuyChart = () => import("@/views/reports/BuyChart");
const BuyChartReport = () => import("@/views/modulePages/commerceModule/BuyChartReport");
const SaleChartReport = () => import("@/views/modulePages/commerceModule/SaleChartReport");
const WareProfit = () => import("@/views/panel/inventory/ware/WareProfit");
const ServicesProfit = () => import("@/views/panel/inventory/ware/ServicesProfit");
const AccountReviewBalance = () => import("@/views/panel/balance/accounts/AccountReviewBalance");
const NewBalanceSheet = () => import("@/views/panel/balanceSheet/NewBalanceSheet");

export default [{
  name: 'Reports',
  path: '/report',
  component: Panel,
  children: [{
      name: 'TransfersList',
      path: 'lists/transfers',
      component: TransfersList,
    },
    {
      name: 'SanadsList',
      path: 'lists/sanads/:type?',
      component: SanadsList,
      props: true
    },
    {
      name: 'SanadItemsList',
      path: 'lists/sanadItems',
      component: SanadItemsList,
    },
    {
      name: 'FactorsAggregatedSanadsList',
      path: 'lists/factors/aggregatedSanads/:type',
      component: FactorsAggregatedSanadsList,
      props: true
    },
    {
      name: 'FactorsList',
      path: 'lists/factors/:type/:isPreFactor',
      component: FactorsList,
      props: (route) => {
        let isPreFactor = [true, 'true'].includes(route.params.isPreFactor)
        return {
          ...route.params,
          isPreFactor: isPreFactor
        }
      }
    },
    {
      name: 'TransactionsList',
      path: 'lists/transactions/:type',
      component: TransactionsList,
      props: true
    },
    {
      name: 'ImprestSettlementsList',
      path: 'lists/imprestSettlements',
      component: ImprestSettlementsList
    },
    {
      name: 'ChequesList',
      path: 'lists/cheques/:type/:isPaid',
      component: ChequesList,
      props: true
    },
    {
      name: 'AdjustmentsList',
      path: 'lists/adjustments/:type',
      component: AdjustmentsList,
      props: true
    },
    {
      name: 'WarehouseHandlingList',
      path: 'lists/warehouseHandling',
      component: WarehouseHandlingList,
    },
    {
      name: 'SalePricesList',
      path: 'lists/salePrices',
      component: SalePricesList,
    },

    {
      name: 'AccountsCoding',
      path: 'accountsCoding',
      component: AccountsCoding,
    },
    {
      name: 'AccountsBalanceReport',
      path: 'balance/accounts',
      component: AccountsBalance,
    },
    {
      name: 'AccountReviewBalance',
      path: 'balance/review',
      component: AccountReviewBalance,
    },
    {
      name: 'FloatAccountsBalanceReportByGroup',
      path: 'balance/floatAccountsByGroup/:is_cost_center?',
      component: FloatAccountsBalanceByGroup,
      props: true
    },
    {
      name: 'FloatAccountsBalanceReport',
      path: 'balance/floatAccounts/:is_cost_center?',
      component: FloatAccountsBalance,
      props: true
    },
    {
      name: 'LedgerReport',
      path: 'ledger/:level?',
      component: Ledger,
      props: (route) => {
        return {
          ledgerAccountIds: route.query.accs,
          ...route.params
        }
      },
    },
    {
      name: 'BillReport',
      path: 'bill/:accountId?',
      component: Bill
    },
    {
      name: 'DetailedWareInventoryReport',
      path: 'inventory/ware/detailed',
      component: DetailedWareInventory,
    },
    {
      name: 'DetailedWarehouseInventoryReport',
      path: 'inventory/warehouse/detailed',
      component: DetailedWarehouseInventory,
      props: (route) => {
        return {
          warehouseId: route.query.warehouseId
        }
      }
    },
    {
      name: 'AllWaresInventoryReport',
      path: 'inventory/ware/all',
      component: AllWaresInventory,
    },
    {
      name: 'AllWarehousesInventoryReport',
      path: 'inventory/warehouse/all',
      component: AllWarehousesInventory,
    },
    {
      name: 'JournalReport',
      path: 'journal',
      component: Journal,
    },
    {
      name: 'IncomeStatementReport',
      path: 'incomeStatement/:detailed?',
      component: IncomeStatement,
      props: true,
    },
    {
      name: 'BalanceSheetReport',
      path: 'balanceSheet/:detailed?',
      component: BalanceSheet,
      props: true,
    },
    {
      name: 'BuySaleReport',
      path: 'buySaleReport/:type',
      component: BuySaleReport,
      props: (route) => {
        return {
          wareId: route.query.wareId,
          ...route.params
        }
      }
    },
    {
      name: 'InventoryProfitReport',
      path: 'inventoryProfitReport',
      component: InventoryProfitReport,
    },
    {
      name: 'SanadListTabs',
      path: 'lastSanadList',
      component: SanadListTabs,
    },
    {
      name: 'LastChequeTabs',
      path: 'lastChequesList',
      component: ChequeTable,
    },
    {
      name: 'LastFactorTabs',
      path: 'lastFactorsList',
      component: FactorsTable,
    },
    {
      name: 'personReport',
      path: 'personReport/:buyerOrSeller?',
      component: PersonReport,
    },
    {
      name: 'ContraryToNatureAccountsBalance',
      path: 'contraryToNatureAccountsBalance',
      component: ContraryToNatureAccountsBalance,
    },
    {
      name: 'BuyChartReport',
      path: 'buyChartReport',
      component: BuyChartReport,
    },
    {
      name: 'SaleChartReport',
      path: 'saleChartReport',
      component: SaleChartReport,
    },
    {
      name: 'WareProfitReport',
      path: 'wareProfit',
      component: WareProfit,
    },
    {
      name: 'ServicesProfitReport',
      path: 'servicesProfit',
      component: ServicesProfit,
    },
    {
      name: 'NewBalanceSheet',
      path: 'newBalanceSheet',
      component: NewBalanceSheet,
    },

  ]
}]